var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"6"}},[_c('work-space-form',{ref:"form",attrs:{"workspace":_vm.WORKSPACE},on:{"updated":_vm.onUpdatedForm}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }